import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const STORAGE_KEY = 'linguise:token';
const STORAGE_PLUGIN_KEY = 'linguise:plugin-token';

/**
 * Set the token
 *
 * @param token string
 */
function set(token) {
    // Move to local storage
    localStorage.setItem(STORAGE_KEY, token);
    // cookies.set('token', token, { path: '/', secure: import.meta.env.VITE_USE_HTTPS==='1', sameSite: 'strict' });
}

/**
 * Retrieve the token value from a cookie
 *
 * @return {string|null}
 */
function get() {
    // Check local storage first
    const localStorageToken = localStorage.getItem(STORAGE_KEY);
    if (localStorageToken) {
        return localStorageToken;
    }
    const cookieToken = cookies.get('token');
    if (cookieToken) {
        // Set to local storage
        set(cookieToken);
        cookies.remove('token', { path: '/' });
        return cookieToken;
    }
    return null;
}

/**
 * Remove the token from cookie content
 */
function remove() {
    cookies.remove('token', { path: '/' });
    // Also remove from local storage
    localStorage.removeItem(STORAGE_KEY);
}

function setPluginToken(token) {
    localStorage.setItem(STORAGE_PLUGIN_KEY, token);
}

function getPluginToken() {
    const localStorageToken = localStorage.getItem(STORAGE_PLUGIN_KEY);
    if (localStorageToken) {
        return localStorageToken;
    }
    return null;
}

function removePluginToken() {
    localStorage.removeItem(STORAGE_PLUGIN_KEY);
}

const cookieToken = {
    set,
    get,
    remove,
    setPluginToken,
    getPluginToken,
    removePluginToken,
};

export default cookieToken;
